import React from 'react';
import PrepaidCardPage from './../components/PrepaidCardPage';
import './../styles/prepaidCard-page.css'

const PrepaidCardCantainer = ({history}) => (
    <PrepaidCardPage history={history} />
);

export default PrepaidCardCantainer;


// WEBPACK FOOTER //
// ./src/containers/PrepaidCardCantainer.js